import { render, staticRenderFns } from "./BookingSearch.vue?vue&type=template&id=fca2bf7c&scoped=true"
import script from "./BookingSearch.vue?vue&type=script&lang=js"
export * from "./BookingSearch.vue?vue&type=script&lang=js"
import style0 from "./BookingSearch.vue?vue&type=style&index=0&id=fca2bf7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2bf7c",
  null
  
)

export default component.exports